import React, { useEffect, useRef, useState } from "react";
import ListaVerificacionService from "../../../services/listaVerificacionService";
import {
  IGetPersonaByEquipo,
  IPersonaByEquipo,
} from "../../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo";
import { ISearchBox } from "@fluentui/react";
import { IPaginacion, InitialFilter } from "../../../Interfaces/filter";
import { IException } from "../../../Interfaces/base/IBase";
import { IDeletePersonaModeloEquipo } from "../../../Interfaces/IAutorizacionModeloEquipo";
import { IResponsePost } from "../../../Interfaces/base/IResponse";

export const useAsignacionPersonasEquipo = (modeloId, isOpen) => {
  const [item, setItems] = useState<IPersonaByEquipo[]>([]);
  const [response, setResponse] = useState<IResponsePost>(null!);
  const [loading, setLoading] = useState(false);
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);

  const searchBoxRefTable = useRef<ISearchBox>(null);
  const [filterTable, setFilterTable] = useState<IGetPersonaByEquipo>({
    equipoModeloId: modeloId,
    skip: 0,
    take: 50,
    search: "",
  });
  const _onkeyUpSearchModeloEquipo = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    if (event.code === "Enter") {
      setFilterTable({ ...filterTable, search: value });
    }
  };
  const onClickNext = () => {
    let valueSkip = filterTable.skip;
    setFilterTable({ ...filterTable, skip: valueSkip + 1 });
  };

  const onClickPrevius = () => {
    let valueSkip = filterTable.skip;
    setFilterTable({ ...filterTable, skip: valueSkip - 1 });
  };

  const getPersonasModeloEquipo = () => {
    setLoading(true);
    ListaVerificacionService.listarAutorizaciones(filterTable)
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          console.log("esta es la respuesta", res.data);
          setItems(res.data.items);
          setPaginacion({
            page: res.data.page,
            pages: res.data.pages,
            total: res.data.total,
          });
        } else {
          setLoading(false);
        }
      })
      .catch((err: IException) => {
        setLoading(false);
      });
  };

  const deletePersonaByModeloEquipo = (data: IDeletePersonaModeloEquipo) => {
    ListaVerificacionService.eliminarAutorizacion(data).then((res) => {
      if (res.status === 200) {
        setResponse(res.data);
        getPersonasModeloEquipo();
      }
    });
  };

  const ocultarMensaje = () => {
    setResponse(null!);
  };

  useEffect(() => {
    if (filterTable.equipoModeloId !== "") {
      getPersonasModeloEquipo();
    }
  }, [filterTable]);
  useEffect(() => {
    if (!isOpen) {
      setItems([]);
    } else {
      filterTable.equipoModeloId = modeloId;
      getPersonasModeloEquipo();
    }
  }, [isOpen]);

  return {
    loading,
    item,
    paginacion,
    searchBoxRefTable,
    response,
    onClickNext,
    onClickPrevius,
    ocultarMensaje,
    _onkeyUpSearchModeloEquipo,
    deletePersonaByModeloEquipo,
  };
};
